import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";

export default function Supports({ title, data }) {
    const [gridApi, setGridApi] = useState(null);
    const supports = data?.dispatch?.supports ?? [];
    const formatDateTime = ({ value }) => value?.replace(/:\d{2}$/, "") ?? "";

    const colummDefs = useMemo(() => ([
        { headerName: "Talão", field: "dispatch_numbercheckbook", flex: 1 },
        { headerName: "D/H inicial", field: "dispatch_start", flex: 1.5, valueFormatter: formatDateTime },
        { headerName: "D/H final", field: "dispatch_end", flex: 1.5, valueFormatter: formatDateTime },
        { headerName: "Guarnição", field: "garrison_name", flex: 3 },
        { headerName: "Contigentes", field: "contingent_namewar", flex: 2 },
    ]), []);

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <div className="w-full print:hidden">
                <AgGridReact
                    rowData={supports}
                    columnDefs={colummDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={AgGridUtils.generalTheme({ headerTextColor: "#676a6c" })}
                    domLayout="autoHeight"
                    onGridReady={(params) => setGridApi(params.api)}
                    suppressRowHoverHighlight={true}
                />
            </div>
            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3]">
                <PrintableTableAgGrid
                    gridApi={gridApi}
                    className="!border-0 w-full -mx-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}
